import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { sendUserMessage } from '../../redux/UserActions'


export default function ChatInput(props) {
    const userSelector = useSelector((state) => state.user);
    const dispatch = useDispatch()

    const [content, setContent] = useState(false)


    function sendMessage() {
        document.getElementById('message-input').value = ""
        dispatch(sendUserMessage({
            'caseId': props.caseId,
            'body': content
        }))
    }

    return (
        props.status === 'open' ?
            <>
                <div
                    className="absolute bottom-0 border-t flex flex-row h-20 rounded w-full">
                    <input
                        id="message-input"
                        onChange={(e) => setContent(e.target.value)}
                        className="flex-1 rounded border border-gray-400 my-2 mx-2" />
                    <button
                        onClick={() => sendMessage()}
                        className="flex-none rounded-lg bg-blue-100 text-lg font-medium my-2 mr-2 px-6">
                        Send
                    </button>
                </div >
            </>
            :
            null
    );
};